// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Sidebar_logoContainer__3qJMO","sidebar":"Sidebar_sidebar__3u9md"};